export class OrderUpdateModel {

	public Id: number;
	public Uuid: string;
	public Notes: string;
	public NotesCustomerService: string;
	public VisitDate: string;
	public VisitDateWithUserOffset: string | null;
	public EarliestDeliveryDate: string;
	public EarliestDeliveryDateWithUserOffset: string | null;
	public FairId: string | null;
	public FairName: string | null;
	AllowPartialShipment: boolean;
	PaymentTerms: string | null;
	FullAddress: string;
	ShipToName: string;
	ShipToId: number | null;
	NoVisit: boolean;
	CheckedConfirmationEmailAddresses: string[];
	public Signature: string;
	public ShopInfos: string;
}
